export default __webpack_public_path__ + "static/media/black-seat.a70bb52e.svg";